import React, {useEffect} from "react";
import styles from './FacebookLoginButton.module.scss';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import {Button} from '@material-ui/core';
import FacebookIcon from '@material-ui/icons/Facebook';
import {config, linksMap} from 'data/utils/constants';
import SkeletonPlaceHolder from 'gui/components/skeletonPlaceHolder';

interface IFacebookLoginButtonProps {
  text: string;
  onSubmit: (formValues) => void;
  disabled: boolean;
  onlyAuth?: boolean;
  style?: any;
  onClick?: () => void;
  forceChangeTokenKey?: number;
  facebookState?: any;
  access_token?: string;
  pathname?: string;
  loading?: boolean;
}


const FacebookLoginButton = ({forceChangeTokenKey, loading, ...props}: IFacebookLoginButtonProps) => {
  return (
    <FacebookLogin
      appId={config.facebook.appId}
      callback={(r) => {
        if (props.onlyAuth) {
          r.onlyAuth = props.onlyAuth;
        }
        props.onSubmit(r);
      }}
      fields=""
      scope=""
      responseType='token'
      access_token={props.access_token}
      redirectUri={`${config.web_client.baseUrl}/${linksMap.login}`}
      state={JSON.stringify({facebook: true, redirect: props.pathname})}
      autoLoad={props.facebookState.facebook && props.access_token}
      render={renderProps => loading ? <SkeletonPlaceHolder
          className={styles.facebookButton}
        /> :
        (

          <Button
            className={`loginButtons ${styles.facebookButton}`}
            fullWidth
            variant="contained"
            onClick={props.onClick || renderProps.onClick}
            disabled={renderProps.disabled || props.disabled}
            style={props.style}
          >
            {props.text}
            <FacebookIcon style={{marginRight: 4}}/>
          </Button>
        )}
    />
  );
};

FacebookLoginButton.defaultProps = {
  disabled: false,
  text: "התחבר עם פייסבוק",
  forceChangeTokenKey: 0,
  loading: false,
};

export default React.memo(FacebookLoginButton);
